import {
  SR_SENTRY_ERROR_CODES_TO_IGNORE,
} from 'common/errorCodes';

export default function shouldLogError(error) {
  if (
    !error
    || SR_SENTRY_ERROR_CODES_TO_IGNORE.includes(error.name)
    || !error.message
    || error.message.includes('users_email_unique')
    || error.message.includes('userBookmarks_pkey')
  ) {
    return false;
  }

  return true;
}
